// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"jut__ButtonLink__buttonLink"};